function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M368 184C368 159.837 363.241 135.91 353.994 113.586C344.747 91.2623 331.194 70.9783 314.108 53.8923C297.022 36.8064 276.738 23.253 254.414 14.0062C232.09 4.7593 208.163 -1.05621e-06 184 0C159.837 1.05621e-06 135.91 4.7593 113.586 14.0062C91.2626 23.253 70.9786 36.8064 53.8926 53.8924C36.8066 70.9783 23.2533 91.2624 14.0064 113.586C4.75954 135.91 0.000242028 159.837 0.000244141 184L184 184H368Z",
  fill: "#0d0816"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M334.546 184C334.546 164.23 330.652 144.654 323.086 126.389C315.521 108.124 304.432 91.528 290.452 77.5486C276.473 63.5691 259.877 52.48 241.612 44.9144C223.347 37.3488 203.77 33.4548 184.001 33.4548C164.231 33.4548 144.654 37.3488 126.389 44.9144C108.124 52.48 91.5283 63.5692 77.5488 77.5486C63.5694 91.528 52.4803 108.124 44.9147 126.389C37.349 144.654 33.4551 164.23 33.4551 184L184.001 184H334.546Z",
  fill: "#faf6ff"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 326.182,
  cy: 41.8182,
  r: 41.8182,
  fill: "#0d0816"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 184C0 208.163 4.75931 232.09 14.0062 254.414C23.253 276.738 36.8064 297.022 53.8924 314.108C70.9783 331.194 91.2624 344.747 113.586 353.994C135.91 363.241 159.837 368 184 368C208.163 368 232.09 363.241 254.414 353.994C276.738 344.747 297.022 331.194 314.108 314.108C331.194 297.022 344.747 276.738 353.994 254.414C363.241 232.09 368 208.163 368 184L184 184L0 184Z",
  fill: "#faf6ff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M32.9998 183.546C32.9998 203.315 36.8938 222.892 44.4594 241.157C52.0251 259.422 63.1142 276.018 77.0936 289.997C91.073 303.977 107.669 315.066 125.934 322.631C144.199 330.197 163.775 334.091 183.545 334.091C203.315 334.091 222.892 330.197 241.157 322.631C259.422 315.066 276.018 303.977 289.997 289.997C303.977 276.018 315.066 259.422 322.631 241.157C330.197 222.892 334.091 203.315 334.091 183.546L183.545 183.546L32.9998 183.546Z",
  fill: "#0d0816"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 41.8181,
  cy: 325.818,
  r: 41.8182,
  transform: "rotate(180 41.8181 325.818)",
  fill: "#faf6ff"
});

function SvgMisc4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 368,
    viewBox: "0 0 368 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisc4);
export default __webpack_public_path__ + "static/media/misc4.56ed9d9f.svg";
export { ForwardRef as ReactComponent };